import React from 'react';
import PropTypes from 'prop-types';
import Button from '@99designs/react-components/components/Button';

export default function CtaButton(props, context) {
    return (
        <Button
            variations={[props.variation, 'fluid']}
            href={props.url}
            isDisabled={props.isDisabled}
        >
            {context.intl.formatMessage({ id: props.messageKey })}
        </Button>
    );
}

CtaButton.contextTypes = {
    intl: PropTypes.object.isRequired,
};

CtaButton.propTypes = {
    variation: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    messageKey: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/CtaButton.jsx